import { useSelector } from 'react-redux';
import { RootState } from '../../redux/Store';
import { Decision_Constants } from '../enum_constants/decision';

const useFollowupReasons = () => {
  const followupReasons = useSelector(
    (state: RootState) => state.contextId.decisionData
  );

  return followupReasons[Decision_Constants?.Follow_Up]?.reasons || [];
};

export default useFollowupReasons;
